import React, { useState } from "react";
import "./ImageWithSkeleton.css";

const ImageWithSkeleton = ({ src, alt, className, fallbackIcon, fallbackClassName }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div className="image-skeleton-wrapper">
      {/* Skeleton Shimmer screen displayed while loading */}
      {!isLoaded && !hasError && (
        <div className="skeleton-shimmer"></div>
      )}
      
      {/* Fallback displayed on error */}
      {hasError ? (
        <div className={`image-error-fallback ${fallbackClassName || ""}`}>
          <span>{fallbackIcon}</span>
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          className={`${className} ${isLoaded ? "image-loaded" : "image-loading"}`}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
          loading="lazy"
        />
      )}
    </div>
  );
};

export default ImageWithSkeleton;
